import React from "react";
import { useSelector } from "react-redux";
import {
  getElementById,
  getContainerClass,
  getLabelStyles,
  getInputStyles,
} from "../utils/styleUtils";

export const CustomTextInput = ({ instanceId, field, form, ...props }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Text input element not found</div>;
  }

  const elementStyle = element.style || {};
  const labelPosition = elementStyle.labelPosition || "top";

  const handleInputChange = (e) => {
    if (field && form) {
      form.setFieldValue(field.name, e.target.value);
    }
  };

  return (
    <div className={getContainerClass(labelPosition)} style={{ width: "100%" }}>
      {elementStyle.label?.label && (
        <label
          htmlFor={`input-${instanceId}`}
          style={getLabelStyles(elementStyle, labelPosition)}
        >
          {elementStyle.label.label}
          {elementStyle.isRequired && (
            <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
          )}
        </label>
      )}

      <input
        id={`input-${instanceId}`}
        type={elementStyle.inputType || "text"}
        placeholder={elementStyle.placeholderText || ""}
        value={field?.value || ""}
        onChange={handleInputChange}
        required={elementStyle.isRequired}
        minLength={elementStyle.minLength}
        maxLength={elementStyle.maxLength}
        pattern={elementStyle.customRegex || undefined}
        style={getInputStyles(elementStyle, labelPosition)}
        className="form-control"
        {...props}
      />

      {elementStyle.helpText && (
        <small className="text-muted mt-1" style={{ fontSize: "0.75rem" }}>
          {elementStyle.helpText}
        </small>
      )}
    </div>
  );
};
